import * as React from 'react';
import { loadAttributes } from 'lib/context';
import { Main } from './main';

const PreLoaderComponent = ({ dispatch, videoDelete, loading }: any) => {
  React.useEffect(() => {
    loadAttributes({ dispatch });
  }, [dispatch]);

  return (
    <Main dispatch={dispatch} videoDelete={videoDelete} loading={loading} />
  );
};

export const PreLoader = React.memo(PreLoaderComponent);
